module.exports = __webpack_public_path__ + "static/media/ck.cd9e4888.svg";